import { useEffect, useState } from "react";

import { PayoutButton } from "@/features/PayoutButton";

import { Input } from "@/shared/ui/input";
import { Label } from "@/shared/ui/label";
import { Modal } from "@/shared/ui/Modal";
import { useGetRandomQuote } from "@/widgets/RandomQuoteModal";
import { Button } from "@/shared/ui/button";
import { useSessionStore } from "@/entities/session";
import { getUSDTBalance } from "@/entities/balance/utils/get-balance";

export const PayoutModal = ({
  open,
  onOpenChange,
  onClose,
  setQuote,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onClose: () => void;
  setQuote: (quote: { text: string; author: string }) => void;
}) => {
  const [wallet, setWallet] = useState("");
  const [amount, setAmount] = useState("");

  const { user } = useSessionStore();

  const { randomQuote } = useGetRandomQuote({ open });

  useEffect(() => {
    if (randomQuote) {
      setQuote(randomQuote);
    }
  }, [randomQuote]);

  return (
    <Modal open={open} onOpenChange={onOpenChange}>
      <Modal.Trigger>Выплата</Modal.Trigger>
      <Modal.Content>
        <Modal.Title>Создать выплату</Modal.Title>
        <div className="mt-2 flex flex-col gap-1">
          <Input
            placeholder="Введите кошелек"
            onChange={(e) => setWallet(e.target.value)}
            value={wallet}
          />
          {wallet.includes(" ") && (
            <Label className={"mb-2 ml-4 text-red-500"}>
              В адресе кошелька не должно быть пробелов!
            </Label>
          )}
          <span className="mb-2 ml-4 text-xs text-gray-600 md:text-sm">
            Выплаты осуществляются исключительно по сети TRC20. Будьте
            внимательны при вводе адреса.
          </span>
        </div>

        <div className="flex w-full items-center gap-1">
          <div className="flex-1">
            <Input
              placeholder="Сумма выплаты"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />
          </div>
          <Button
            className="h-full"
            onClick={() => {
              setAmount(String(getUSDTBalance(user?.balances)[0]));
            }}
          >
            Все
          </Button>
        </div>

        <div className="flex flex-col gap-2 pt-2">
          <PayoutButton wallet={wallet} amount={amount} onClose={onClose} />

          <Modal.Close />
        </div>
      </Modal.Content>
    </Modal>
  );
};
